﻿"use strict";

angular.module('app.financeiro').factory('comprovantePagamentoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'ReciboPagamento';

    var _list = function (search, options, codigoParametroBancoPagamento, dtInicio, dtTermino, nroProposta) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParametroBancoPagamento", "value": codigoParametroBancoPagamento });
        dto.parms.push({ "name": "DtInicio", "value": dtInicio });
        dto.parms.push({ "name": "DtTermino", "value": dtTermino });
        dto.parms.push({ "name": "NroProposta", "value": nroProposta });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _listAll = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAll');
    };

    var _listParamentroPagamento = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListParamentroPagamento');
    };

    var _impressaoComprovante = function (codigoRemessa) {
        var dto = {};
        dto.id = codigoRemessa;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ImpressaoComprovante', dto);
    };

    var factory = {};

    factory.findRecord = _findRecord;
    factory.list = _list;
    factory.listAll = _listAll;
    factory.listParamentroPagamento = _listParamentroPagamento;
    factory.impressaoComprovante = _impressaoComprovante;

    return factory;

}]);
